import React from 'react';
import { Droppable, Draggable } from '@hello-pangea/dnd';
import { CheckCircle2 } from '../../../../shared/assets/AppIcons';
import CompletedDealCard from './CompletedDealCard';

const CompletedStageColumn = ({
  stage,
  deals,
  onCardClick,
  onOpenClient,
  onOpenStaff,
  staff = [],
}) => {
  return (
    <section className="deals-column">
      <div className="deals-column__header">
        <h3 className="deals-column__title">{stage}</h3>
        <p className="deals-column__count">
          <CheckCircle2 size={16} aria-hidden="true" /> {deals.length} saldati
        </p>
      </div>

      <Droppable droppableId={stage}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className={snapshot.isDraggingOver ? 'deals-column__body is-over' : 'deals-column__body'}
          >
            {deals.map((deal, index) => (
              <Draggable key={deal.id} draggableId={String(deal.id)} index={index}>
                {(providedDraggable, snapshotDraggable) => (
                  <CompletedDealCard
                    deal={deal}
                    onClick={onCardClick}
                    onOpenClient={onOpenClient}
                    onOpenStaff={onOpenStaff}
                    staff={staff}
                    variant="settled"
                    provided={providedDraggable}
                    snapshot={snapshotDraggable}
                  />
                )}
              </Draggable>
            ))}

            {provided.placeholder}

            {deals.length === 0 && !snapshot.isDraggingOver && (
              <div className="deals-column__empty">Nessun affare saldato in questa fase</div>
            )}
          </div>
        )}
      </Droppable>
    </section>
  );
};

export default CompletedStageColumn;
